import { FC, PropsWithChildren } from "react";
import { NavDescriptionProps } from "./NavDescription.props";
import classNames from "classnames";
import styles from "./NavDescription.module.scss";

/**
 * The navigation item description component.
 */
export const NavDescription: FC<PropsWithChildren<NavDescriptionProps>> = (props: PropsWithChildren<NavDescriptionProps>) => {
  const { id, testId, className, children } = props;

  const navDescriptionClasses = classNames("nav-description", styles.navDescription, className);

  return (
    <div id={id} data-testid={testId ? `test__${testId}-nav-description` : undefined} className={navDescriptionClasses}>
      {children}
    </div>
  );
};
